import style from './MobileViewSeparator.module.css';

export function MobileViewSeparator() {
    return <hr className={style.separator} />;
}
